function Star5(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M450 210H312.4l97.3-97.3a30 30 0 1 0-42.4-42.4L270 167.6V30a30 30 0 1 0-60 0v137.6l-97.3-97.3a30 30 0 1 0-42.4 42.4l97.3 97.3H30a30 30 0 1 0 0 60h137.6l-97.3 97.3a30 30 0 1 0 42.4 42.4l97.3-97.3V450a30 30 0 1 0 60 0V312.4l97.3 97.3a30 30 0 1 0 42.4-42.4L312.4 270H450a30 30 0 1 0 0-60Z"></path></svg>
    )
}

export default Star5